import { ActiveCheat, CheatType } from './types';

export const CheatManagerToken = Symbol('CheatManager');

export class CheatManager {
  private activeCheat: ActiveCheat[] | null = null;
  private subscribers: ((cheat: ActiveCheat[] | null) => void)[] = [];

  private fastSpinMode: boolean = false;

  public subscribe(callback: (cheat: ActiveCheat[] | null) => void): void {
    this.subscribers.push(callback);
  }

  public unsubscribe(callback: (cheat: ActiveCheat | null) => void): void {
    this.subscribers = this.subscribers.filter((cb) => cb !== callback);
  }

  private notifySubscribers(): void {
    const activeCheat = this.activeCheat || [];

    this.subscribers.forEach((callback) => callback(activeCheat));
  }

  public getActiveCheat(): ActiveCheat[] | null {
    const activeCheat = [...(this.activeCheat || [])];

    activeCheat.forEach((cheat) => {
      if (cheat.once) {
        this.resetActiveCheatByType(cheat.type);
      }
    });

    this.notifySubscribers();

    return activeCheat;
  }

  public resetAllCheats(): void {
    this.activeCheat = null;
    this.notifySubscribers();
  }

  public setActiveCheat(cheat: ActiveCheat | null): void {
    if (!cheat) {
      return;
    }

    const activeCheat = (this.activeCheat || []).find(
      (activeCheat) => activeCheat.type === cheat.type
    );

    if (activeCheat) {
      this.activeCheat = (this.activeCheat || []).map((activeCheat) =>
        activeCheat.type === cheat.type ? cheat : activeCheat
      );
    } else {
      this.activeCheat = [...(this.activeCheat || []), cheat];
    }

    this.notifySubscribers();
  }

  public resetActiveCheatByType(type: CheatType): void {
    this.activeCheat =
      (this.activeCheat || []).filter((activeCheat) => activeCheat.type !== type) || null;
    this.notifySubscribers();
  }

  public applyConfig(configValue: string): void {
    this.setActiveCheat({
      type: CheatType.Config,
      value: configValue,
    });
  }

  public resetConfig(): void {
    this.resetActiveCheatByType(CheatType.Config);
  }

  public applyCustomCheat(customValue: string): void {
    this.setActiveCheat({
      type: CheatType.Config,
      value: customValue,
    });
  }

  public resetCustomCheat(): void {
    this.resetActiveCheatByType(CheatType.Config);
  }

  public applyCommand(command: string): void {
    this.setActiveCheat({
      type: CheatType.Command,
      once: true,
      value: command,
    });
  }

  public applyReelSet(reelsValue: any, once: boolean = false): void {
    this.setActiveCheat({
      type: CheatType.Reels,
      once,
      value: reelsValue,
    });
  }

  public resetReelSet(): void {
    this.resetActiveCheatByType(CheatType.Reels);
  }

  public setFastSpinMode(fastSpinMode: boolean): void {
    this.fastSpinMode = fastSpinMode;
  }

  public getFastSpinMode(): boolean {
    return this.fastSpinMode;
  }
}
